import { CheckCircle2, Loader2, XCircle } from 'lucide-react';

export interface CheckStatusIconProps {
  isChecking: boolean;
  /** `null`/`undefined` = not checked (yet) – no icon. */
  isValid: boolean | null | undefined;
}

/** Live check feedback inside an input, like the self-checkout: spinner while checking, then check or cross. */
const CheckStatusIcon = ({ isChecking, isValid }: CheckStatusIconProps) => {
  if (isChecking) return <Loader2 className="h-4 w-4 animate-spin text-gray-400" />;
  if (isValid === true) return <CheckCircle2 className="h-4 w-4 text-green-500" />;
  if (isValid === false) return <XCircle className="h-4 w-4 text-red-500" />;
  return null;
};

export default CheckStatusIcon;
